<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="d-flex p-3 background-primary-blue height-70px shadow z-max align-items-center">
        <app-back-button/>
        <div class="w-100 d-flex gap-3 justify-content-center align-items-center color-white">
            <div class="col-auto text-center color-white fs-lg">Add animal</div>
        </div>
        <app-close-button/>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        @if (existingDeviceAssociation()) {
            <div class="card p-3">
                Tag '{{ deviceIdentifier }}' is already associated with animal {{ existingDeviceAssociation()?.assetId }}.
                Do you want to delete this animal?
            </div>
            @if (existingAnimal()) {
                <div class="card">
                    <app-animal-button [id]="existingAnimal()!.id"
                                       [clickable]="false"
                                       [selectableForAlteration]="false"
                                       [selectableForDeletion]="false"
                                       [standalone]="true"/>
                </div>
            }
            <div class="d-flex flex-column gap-2">
                <app-generic-button
                    (click)="deleteDeviceAssociation()"
                    description="Delete animal"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-danger btn-danger-shadow'"
                    [buttonText]="'Delete animal'"
                    [primaryIcon]="'fa-solid fa-trashcan'"/>
                <app-generic-button
                    (click)="reset()"
                    description="Cancel adding new animal"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    [buttonText]="'Cancel'"/>
        </div>
        } @else if (!deviceToMatch) {
            <app-device-id-input
                (deviceIdSelected)="onDeviceIdSelected($event)"
                [deviceName]="'tag'"
                [inputLength]="5" />
        } @else {
            <div>
                <div class="row">
                    <div class="fw-bold">Associated device ID: {{ deviceIdentifier }}</div>
                </div>
                <div class="row">
                    <div class="input-group">
                        <input (input)="setName($event)"
                                [ngClass]="{'is-invalid': addAnimalStore.name() === undefined}"
                                [value]="addAnimalStore.name() ?? ''"
                                class="form-control m-auto"
                                placeholder="Animal name"
                                required
                                style="padding-right: 30px;"
                                type="text">
                    </div>
                </div>
            </div>

            <app-profile-picture-editor
                (updateImageUrl)="setProfilePictureUrl($event)"/>

            <div>
                <div class="row">
                    <div class="fw-bold">Assigned paddock</div>
                </div>
                <div class="row">
                    <div class="col">
                        <button aria-controls="paddockSelectCollapse"
                                aria-expanded="false"
                                class="btn btn-info dropdown-toggle w-100"
                                data-bs-target="#paddockSelectCollapse"
                                data-bs-toggle="collapse"
                                type="button">
                            {{ addAnimalStore.paddock()?.name || "Select" }}
                        </button>
                        <div class="collapse"
                                id="paddockSelectCollapse">
                            @for (paddock of paddocks(); track paddock.id) {
                                <div (click)="setPaddock(paddock)" aria-controls="paddockSelectCollapse"
                                        class="btn card m-1"
                                        data-bs-target="#paddockSelectCollapse"
                                        data-bs-toggle="collapse">{{ paddock.name }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="row">
                    <div class="col fw-bold">Animal type</div>
                    <div class="col fw-bold">Year born</div>
                </div>
                <div class="row">
                    <div class="col">
                        <button aria-controls="animalTypeCollapse"
                                aria-expanded="false"
                                class="btn btn-info dropdown-toggle w-100"
                                data-bs-target="#animalTypeCollapse"
                                data-bs-toggle="collapse"
                                type="button">
                            {{ addAnimalStore.animalType() || "Select" | toCapitalizedText }}
                        </button>
                        <div class="collapse"
                                id="animalTypeCollapse">
                            @for (animalType of animalTypes; track animalType) {
                                <div (click)="setAnimalType(animalType)"
                                        aria-controls="animalTypeCollapse" class="btn card m-1"
                                        data-bs-target="#animalTypeCollapse"
                                        data-bs-toggle="collapse">{{ animalType | toCapitalizedText }}
                                </div>
                            }
                        </div>
                    </div>
                    <div class="col dropdown">
                        <button aria-controls="yobCollapse"
                                aria-expanded="false"
                                class="btn btn-info dropdown-toggle w-100"
                                data-bs-target="#yobCollapse"
                                data-bs-toggle="collapse"
                                id="yobDropdownMenuButton"
                                type="button">
                            {{ addAnimalStore.year() || "Select" }}
                        </button>
                        <div class="collapse"
                                id="yobCollapse">
                            @for (year of years; track year) {
                                <div (click)="setYob(year)"
                                        aria-controls="yobCollapse"
                                        class="btn card m-1"
                                        data-bs-target="#yobCollapse"
                                        data-bs-toggle="collapse">{{ year }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <app-create-weight-measurement
                (weightMeasurementCreated)="setWeightMeasurement($event)"/>

            <div>
                <div class="row">
                    <div class="m-0 fw-bold">Comments</div>
                    <div class="d-flex justify-content-center">
                        <textarea (change)="setComment($event)"
                                    class="rounded-2 m-1 width-400px height-100px"
                                    type="text"
                                    value="{{addAnimalStore.comment()}}"></textarea>
                    </div>
                </div>
            </div>

            <app-generic-button
                (click)="processNewAnimal()"
                description="Create new animal"
                [alwaysShowText]="true"
                [buttonText]="'Add'"
                [disabled]="!canProcessNewAnimal()"
                [loading]="loading()"
                [primaryIcon]="'fa-solid fa-check'"/>
        }
    </div>
</div>
